import { makeNamespacedComponent } from '../utils';
import { Button, Group } from './atoms';

const RadioGroup = makeNamespacedComponent(Group, {
  Button,
});

export { RadioGroup };
